/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskq8"
      );
    },
    registered() {
      console.log("Service Worker registrado exitosamente");
      // Verificar actualizaciones cada 30 segundos después del registro
      setInterval(() => {
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.getRegistration().then((reg) => {
            if (reg) {
              console.log("[SW] Verificando actualizaciones...");
              reg.update();
            }
          });
        }
      }, 30000);
    },
    cached() {
      console.log("App ha sido cacheado exitosamente para uso offline.");
    },
    updatefound() {
      console.log("Nuevo Service Worker encontrado, descargando...");
    },
    updated(registration) {
      console.log("Nueva versión del Service Worker disponible");
      document.dispatchEvent(
        new CustomEvent("swUpdated", { detail: registration })
      );
    },
    offline() {
      console.log("Sin conexión a internet.");
    },
    error(error) {
      console.error("Error durante el registro del Service Worker:", error);
    },
  });
}
